import { render } from "./healthReport.vue?vue&type=template&id=567272c0&scoped=true&ts=true"
import script from "./healthReport.vue?vue&type=script&lang=ts"
export * from "./healthReport.vue?vue&type=script&lang=ts"

import "./healthReport.vue?vue&type=style&index=0&id=567272c0&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567272c0"]])

export default __exports__